import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    border: '2px solid rgba(0,0,0,0.2)',
    borderRadius: '4px',
    position: 'absolute',
    height: '100%',
  },
  myLocation: {
    width: 50,
    height: 50,
    background: 'red',
    position: 'absolute',
  },
}));

export default useStyles;
